var map = {
	"./7z.png": "62fe",
	"./csv.png": "01af",
	"./doc.png": "6df4",
	"./docx.png": "575a",
	"./jpg.png": "7bf2",
	"./png.png": "5f28",
	"./rar.png": "a594",
	"./svg.png": "5206",
	"./tar.png": "c31b",
	"./text.png": "7dba",
	"./txt.png": "187b",
	"./xls.png": "5871",
	"./xlsx.png": "ddc5",
	"./zip.png": "f3ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3f8";